'use client';

import { useSelector } from '@castlery/shared-redux-store';
import { selectProduct, selectVariant } from '@castlery/modules-product-domain';
import { Stack, useBreakpoints } from '@castlery/fortress';
import cloneDeep from 'lodash.clonedeep';
import { ProductOptionsLabel } from './product-options-label';
import { ProductOptionsValues } from './product-options-values';
import { ProductVersionOptions } from '../product-version-options/product-version-options';

export const ProductConfigurableOptions = () => {
  const product = useSelector(selectProduct);
  const variant = useSelector(selectVariant);
  const { mobile, tablet } = useBreakpoints();
  return (
    <Stack px={mobile ? 6 : tablet ? 6 : undefined}>
      {product?.option_types?.map((optionType) => {
        const sortOptionType = cloneDeep(optionType);

        return (
          <Stack key={sortOptionType.id} mt={mobile ? 6 : 8}>
            <ProductOptionsLabel optionType={sortOptionType} variant={variant} />
            <ProductOptionsValues sortOptionType={sortOptionType} product={product} variant={variant} />
          </Stack>
        );
      })}
      <ProductVersionOptions product={product} variant={variant} />
    </Stack>
  );
};
